import { FC } from "react";
import { SPECIALITY_PHARMACY } from "src/constants/todos";
import { headerPorps } from "../types";

const PharmacyTableHeader: FC<headerPorps> = ({changeIdOrder,queryParam}) => (
  <thead className="sticky-top z-1">
       <tr className="text-center">
            {SPECIALITY_PHARMACY.map((tableHeader, index) => (
              <th key={index}
                onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
              >
                <span role={tableHeader.value === '' ? "textbox" : "button"}
                  className={
                    tableHeader.value === '' ?
                      'fw-bold fs-6 lh-base' :
                      'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                  }
                >{tableHeader.label}
                  {(queryParam as any).sort_by === tableHeader.value ? (
                    <i className={`bi ${(queryParam as any).direction === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
                  ) : null}
                </span>
              </th>
            ))}
    </tr>
  </thead>
);

export default PharmacyTableHeader;
